import { patchLandingSite } from '@/api/landings';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import type { ILandingSite } from '@/entities/landing.entity';
import { useState } from 'react';
import { toast } from 'sonner';

export default function SiteTelegramAuthToggle({
	site,
	onUpdated,
}: {
	site: ILandingSite;
	onUpdated: () => void;
}) {
	const enabled = site.config?.telegramAuthEnabled !== false;
	const [saving, setSaving] = useState(false);

	async function handleToggle(next: boolean) {
		setSaving(true);
		try {
			await patchLandingSite(site.id, { config: { telegramAuthEnabled: next } });
			toast.success(next ? 'Telegram auth включён' : 'Telegram auth отключён на сайте');
			onUpdated();
		} catch {
			toast.error('Не удалось обновить сайт');
		} finally {
			setSaving(false);
		}
	}

	return (
		<div className='mt-3 flex items-center justify-between gap-3 rounded-lg border border-border bg-muted/20 px-3 py-2'>
			<div className='min-w-0'>
				<Label className='text-sm font-medium'>Telegram auth</Label>
				<p className='text-xs text-muted-foreground'>Вход по номеру на этом сайте</p>
			</div>
			<Switch checked={enabled} disabled={saving} onCheckedChange={handleToggle} />
		</div>
	);
}
